// extracted by mini-css-extract-plugin
export default {"Confirmation":"_Confirmation--ekicP","TextBox":"_TextBox--cpjyk","Paragraph":"_Paragraph--x63rq","HelpCenter":"_HelpCenter--ysHmm","Icon":"_Icon--DhZZB","Heading":"_Heading--lXuc_"};